<style lang="scss"></style>

<style lang="scss" scoped="scoped">
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 0px 10px 10px 20px; background: rgba(3, 0, 108, 1)">
    <div class="biankuang" style="display: flex;flex-direction: column;height: 100%;">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          昨日次品数据
        </div>
      </div>
      <div style="flex:1;display: flex;justify-content: space-around;align-items: center;">
        <div style="text-align: center;">
          <p style="font-size: 18px;color: white;">次品率</p>
          <p style="font-weight: bold;font-size: 40px;color:#6DDF27">{{ rate }}%</p>
        </div>
        <div style="text-align: center;">
          <p style="font-size: 18px;color: white;">次品数量</p>
          <p style="font-weight: bold;font-size: 40px;color:#FF1284">{{ badQuantity }}</p>
        </div>
        <div style="text-align: center;">
          <p style="font-size: 18px;color: white;">生产数量</p>
          <p style="font-weight: bold;font-size: 40px;color:#6DDF27">{{ quantity }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_wait',
  components: {},

  data() {
    return {
      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      badQuantity: 0,
      quantity: 0,
      rate: 0
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/quality/board/totalWoReportRecordByYesterday');
      if (response.data) {
        this.badQuantity = response.data.badQuantity;
        this.quantity = response.data.quantity;
        this.rate = response.data.badRate.toFixed(2);
      }

      this.list = response.data.rows;
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 10;
        this.rowHeight = (this.contentHeight - 42 - 5) / 8;
      }, 800);
    }
  }
};
</script>
